import React, { useState } from 'react';
import { Header, Tab } from 'semantic-ui-react'
import { UpdatesTable } from '../../../components/admin/updates/updatesTab';
import Alert from '../../../utils/alert';
import DatePicker from '../../../components/form/datePicker';
import { getPaneCfg } from '../../../utils/general';
import PromotionAllowance from './components/promotionAllowance';


function GlobalTableUpdates() {
    return <>
        <Header as="h2" textAlign='center'>Table Updates</Header>
        <Tab panes={
            [
                getPaneCfg("Drafts",
                    <UpdatesTable query={{ phases: ["DRAFT"] }} detailed={false} />),
                getPaneCfg("Promotion Allowance", <PromotionAllowance />),
                getPaneCfg("Pending Peer Review",
                    <UpdatesTable query={{ phases: ["READY_FOR_PEER_REVIEW"] }} detailed={false} />),
                getPaneCfg("Pending QA Review",
                    <UpdatesTable query={{ phases: ["READY_FOR_QA_REVIEW"] }} detailed={false} />),
                getPaneCfg("Applied", <AppliedUpdatesTable />),
            ]} />
    </>
}

function AppliedUpdatesTable() {
    const [from, setFrom] = useState(() => new Date(new Date().setDate(new Date().getDate() - 7)))
    const [to, setTo] = useState(() => new Date())

    let fromTM = new Date(from.getTime()).setUTCHours(0, 0, 0, 0)
    const toTM = new Date(to.getTime()).setUTCHours(23, 59, 0, 0)

    if (((to - from) / (1000 * 3600 * 24)) > 31 * 2) {
        Alert.warn("The specified period cannot be higher than 62 days")
        fromTM = to
    }

    return <>
        <DatePicker
            label="From:" date={from}
            onChange={d => setFrom(d)} />
        <DatePicker
            label="To:" date={to}
            onChange={d => setTo(d)} />
        <UpdatesTable
            query={{ phases: ["APPLIED"], appliedAfter: fromTM, appliedBefore: toTM }}
            detailed={false}
            includeMistakes={true} />
    </>
}

export default GlobalTableUpdates
